export default __webpack_public_path__ + "static/media/7ba0ad22c22b1489ee3c513ddc1ca1411577103881887.24280e49.webp";